export const CLINICAL_ADMIN = 1;

export const SUPER_ADMIN = 3;
